<template>
    <div
        class="search-main"
        :class="{ 'search-open': estadoAbertoCalculado }"
        ref="searchContainer"
    >
        <div
            class="circle"
            @click="handleClick"
        >
            <span class="material-symbols-outlined">search</span>
        </div>

        <div :class="['search-navbar', estadoAbertoCalculado ? 'showSearch' : 'hideSearch']">
            <input
                type="search"
                :placeholder="$t('tables.search_bar_placeholder')"
                v-model="searchValue"
                @input="handleInput"
                ref="inputRef"
            />
        </div>
    </div>
</template>

<script>
    import { defineComponent, ref, computed, onMounted, onUnmounted, nextTick, watch } from 'vue'
    import SearchIcon from 'vue-material-design-icons/Magnify.vue'
    import { usePesquisaStore } from '@/stores/pesquisa'
    import { storeToRefs } from 'pinia'

    export default defineComponent({
        name: 'Search',
        components: { SearchIcon },
        props: {
            // initiallyOpen: { type: Boolean, default: false },
            modoLocal: {
                type: Boolean,
                default: false,
            },
        },
        emits: ['update:searchValue'],
        setup(props, { emit }) {
            const pesquisaStore = usePesquisaStore()
            const { estaAbertaPesquisa, estaAbertoMenu, termoPesquisa } = storeToRefs(pesquisaStore)

            const searchValue = ref(props.modoLocal ? '' : termoPesquisa.value)
            const searchContainer = ref(null)
            const inputRef = ref(null)
            const abertoLocalmente = ref(false)

            const estadoAbertoCalculado = computed(() => {
                if (props.modoLocal) {
                    return abertoLocalmente.value
                }
                return estaAbertaPesquisa.value
            })

            const handleInput = () => {
                if (props.modoLocal) {
                    emit('update:searchValue', searchValue.value)
                    return
                }

                pesquisaStore.setTermoPesquisa(searchValue.value)
            }

            watch(termoPesquisa, (novoValor) => {
                if (!props.modoLocal && novoValor !== searchValue.value) {
                    searchValue.value = novoValor || ''
                }
            })
            const handleClick = () => {
                const isMobile = window.innerWidth <= 1148
                const temTexto = searchValue.value && searchValue.value.length > 0

                if (!isMobile && estadoAbertoCalculado.value && temTexto) {
                    return
                }

                if (props.modoLocal) {
                    abertoLocalmente.value = !abertoLocalmente.value
                } else {
                    if (estaAbertoMenu.value) {
                        pesquisaStore.setEstaAbertoMenu(false)
                        setTimeout(() => {
                            pesquisaStore.setEstaAbertaPesquisa(!estaAbertaPesquisa.value)
                        }, 300)
                    } else {
                        pesquisaStore.setEstaAbertaPesquisa(!estaAbertaPesquisa.value)
                        pesquisaStore.setEstaAbertoMenu(false)
                    }
                }

                if (!estadoAbertoCalculado.value) {
                    nextTick(() => inputRef.value?.focus())
                }
            }
            const handleClickOutside = (event) => {
                if (!estadoAbertoCalculado.value) return

                const isMobile = window.innerWidth <= 1148
                const temTexto = searchValue.value && searchValue.value.trim() !== ''

                if (!isMobile && temTexto) {
                    return
                }

                if (searchContainer.value && !searchContainer.value.contains(event.target)) {
                    if (props.modoLocal) {
                        abertoLocalmente.value = false
                    } else {
                        pesquisaStore.setEstaAbertaPesquisa(false)
                    }
                }
            }

            onMounted(() => {
                document.addEventListener('mousedown', handleClickOutside)
            })

            onUnmounted(() => {
                document.removeEventListener('mousedown', handleClickOutside)
            })

            return {
                estadoAbertoCalculado,
                searchValue,
                handleInput,
                handleClick,
                searchContainer,
                inputRef,
            }
        },
    })
</script>

<style lang="scss" scoped>
    .search-main {
        display: inline-flex;
        align-items: center;
        height: 2.7rem;
        border-radius: 1.6rem;
        border: 1px solid #cacaca;
        background-color: #fff;
        overflow: hidden;
        transition: all 0.4s ease;
    }

    .circle {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 2.7rem;
        width: 2.7rem;
        flex-shrink: 0;
        background-color: var(--colorOpacity60);
        cursor: pointer;
        order: 2;
        position: relative;
        z-index: 2;

        &:hover {
            background-color: var(--colorOpacity100);
        }

        .material-symbols-outlined {
            color: #fff;
            font-size: 1.5rem;
        }
    }

    .search-navbar {
        order: 1;
        max-width: 0;
        flex: 1;
        opacity: 0;
        transition:
            max-width 1.5s ease,
            opacity 1s ease;

        input {
            padding-left: 1rem;
            border: none;
            outline: none;
            height: 100%;
            width: 100%;
            font-size: 0.8rem;
            background: transparent;
        }

        input[type='search']::-webkit-search-cancel-button,
        input[type='search']::-webkit-search-decoration {
            -webkit-appearance: none;
            display: none;
        }
    }

    .search-main.search-open .search-navbar {
        max-width: 17vw;
        opacity: 1;
    }

    @media (min-width: 1149px) {
        .search-navbar {
            max-width: 0;
            transition:
                max-width 1.5s ease,
                opacity 1s ease;
        }

        .search-main.search-open .search-navbar {
            max-width: 17vw;
            opacity: 1;
        }
    }

    @media (max-width: 1148px) {
        .search-main:not(.search-open) {
            border-color: transparent;
            background: transparent;
            width: 2.7rem;
            overflow: hidden;
        }

        .search-navbar {
            transition: opacity 0.3s ease;
        }

        .search-main.search-open {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);

            width: 90vw;
            max-width: 400px;
            height: 3.5rem;

            z-index: 9999;
            border-color: #cacaca;

            box-shadow:
                0 4px 20px rgba(0, 0, 0, 0.2),
                0 0 0 100vh rgba(0, 0, 0, 0.6);

            .search-navbar {
                opacity: 1;
                width: 100%;
                max-width: 100%;
                padding-right: 10px;

                input {
                    font-size: 1rem;
                }
            }

            .circle {
                background-color: var(--colorOpacity100);
                border-radius: 0 1.6rem 1.6rem 0;
                height: 100%;
                width: 3.5rem;
            }
        }
    }
</style>
